import { render } from "./CalculadoraEstructura.vue?vue&type=template&id=6785dc82&scoped=true"
import script from "./CalculadoraEstructura.vue?vue&type=script&lang=js"
export * from "./CalculadoraEstructura.vue?vue&type=script&lang=js"

import "./CalculadoraEstructura.vue?vue&type=style&index=0&id=6785dc82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6785dc82"]])

export default __exports__